
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { resolveSubjects } from '../../canvas/commands/CommandUtil';
import { RelativeTo } from '../../canvas/entities/Physical';
import { Physicals } from '../../canvas/entities/Physicals';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { EffectDirector, Effects } from '../../canvas/visualization/EffectDirector';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { DropZone } from './DropZone';
import { DropZonePeekWidget } from './DropZonePeekWidget';

export const dropZoneCreate = defineCommand(
    'dropZoneCreate',
    'Drop Zone: Create',
    cc => Physicals.createAtCameraPosition(cc, DropZone)
);

export const dropZoneDrop = defineCommand(
    'dropZoneDrop',
    'Drop Zone: Drop',
    (cc, [targetId, elmtIds]: [string, string | string[]]) => {

        const objects = cc.call(ObjectManager);
        const effects = cc.call(EffectDirector);

        const zone = objects.get(targetId, DropZone);
        const subjects = resolveSubjects(cc, elmtIds);

        if (!subjects.length) return;

        objects.update(() => {
            const newPos = zone.layout.main.center();

            for (const sub of subjects) {
                const from = sub.transform(RelativeTo.Model);
                zone.add(sub.removeSelf());
                sub.moveTo(newPos.subtract(sub.size().divide(2)));
                const to = sub.transform(RelativeTo.Model);
                effects.trigger(Effects.tween(from, to), sub);
            }
        });
    }
);

export const dropZonePeek = defineCommand(
    'dropZonePeek',
    'Drop Zone: Peek',
    (cc, [targetId]: [string]) => {

        const dispatch = cc.call(CommandDispatcher);
        const effects = cc.call(EffectDirector);
        const objects = cc.call(ObjectManager);
        const tools = cc.call(ToolManager);
        const widgets = cc.call(WidgetManager);

        const subject = objects.get(targetId, DropZone);

        widgets.delete('dropZonePeek');

        const cont = widgets.createContainer({
            name: 'dropZonePeek',
            position: ['attached', { to: subject.id, placement: 'right', offset: [1, 2] }],
            direction: 'row',
            style: 'none',
        });

        cont.add(widgets.createInline({ ui: DropZonePeekWidget, subject }));
        widgets.add(cont);
        return true;
    }
);

export const dropZoneUnpeek = defineCommand(
    'dropZoneUnpeek',
    'Drop Zone: Unpeek',
    (cc) => {

        const widgets = cc.call(WidgetManager);
        widgets.delete('dropZonePeek');
    }
);

export const inDropZoneCommands = () => inCommands(
    dropZonePeek,
    dropZoneUnpeek,
    dropZoneCreate,
    dropZoneDrop,
);

